interface Props {
  size?: number;
  color?: string;
}

const ReportIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <g clipPath="url(#clip0_1677_3046)">
        <path
          d="M13.6847 15.7153H12.1847V18.7153H13.6847V15.7153Z"
          fill={color}
        />
        <path
          d="M17.4347 14.2153H15.9347V18.7153H17.4347V14.2153Z"
          fill={color}
        />
        <path
          d="M9.93469 11.2153H8.43469V18.7153H9.93469V11.2153Z"
          fill={color}
        />
        <path
          d="M19.6847 4.46533H17.4347V3.71533C17.4347 3.31751 17.2767 2.93598 16.9954 2.65467C16.714 2.37337 16.3325 2.21533 15.9347 2.21533H9.93469C9.53687 2.21533 9.15534 2.37337 8.87403 2.65467C8.59273 2.93598 8.43469 3.31751 8.43469 3.71533V4.46533H6.18469C5.78687 4.46533 5.40534 4.62337 5.12403 4.90467C4.84273 5.18598 4.68469 5.56751 4.68469 5.96533V21.7153C4.68469 22.1132 4.84273 22.4947 5.12403 22.776C5.40534 23.0573 5.78687 23.2153 6.18469 23.2153H19.6847C20.0825 23.2153 20.464 23.0573 20.7454 22.776C21.0267 22.4947 21.1847 22.1132 21.1847 21.7153V5.96533C21.1847 5.56751 21.0267 5.18598 20.7454 4.90467C20.464 4.62337 20.0825 4.46533 19.6847 4.46533ZM9.93469 3.71533H15.9347V6.71533H9.93469V3.71533ZM19.6847 21.7153H6.18469V5.96533H8.43469V8.21533H17.4347V5.96533H19.6847V21.7153Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1677_3046">
          <rect
            width={24}
            height={24}
            fill={color}
            transform="translate(0.934692 0.715332)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReportIcon;
